'use strict';/* global define */define('modules/core/modules/app/services/theme-switcher/index',['require','exports','module','angular'],function(require,exports,module){'use strict';var ng=require('angular');var root=document.querySelector('html');// @ngInject
function service(){// jshint validthis:true
// jshint latedef:false
this.setTheme=setTheme;// --
/**
     * Set the app theme
     *
     * @param {String}           theme   - Theme name
     * @param {Object|Undefined} options - Possible config options
     *
     * @tested
     */function setTheme(theme,options){options=options||{};if(!options.element){ng.element(root).attr('data-theme',theme);}else{if(typeof options.element!=='string'){ng.element(options.element).attr('data-theme',theme);}else{ng.element(document.querySelector(options.element)).attr('data-theme',theme);}}}}module.exports=service;});
